import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Sparkles, Zap, Wand2, AlertTriangle } from 'lucide-react';
interface SlideAIEconomicsProps {
  onContinue: () => void;
}
export function SlideAIEconomics({
  onContinue
}: SlideAIEconomicsProps) {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), 400);
    const t2 = setTimeout(() => setStage(2), 1200);
    const t3 = setTimeout(() => setStage(3), 2000);
    const t4 = setTimeout(() => setStage(4), 2900);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      clearTimeout(t4);
    };
  }, []);
  return <div className="h-full w-full flex flex-col items-center px-8 py-10 md:px-20 md:py-14 max-w-7xl mx-auto" data-id="element-130">
      {/* Sparkle icon */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: stage >= 1 ? 1 : 0,
      scale: stage >= 1 ? 1 : 0.8
    }} transition={{
      duration: 0.5
    }} className="mb-6" data-id="element-131">
        <div className="w-14 h-14 rounded-2xl bg-teal-400/10 border border-teal-400/30 flex items-center justify-center" data-id="element-132">
          <Sparkles className="w-6 h-6 text-teal-400" data-id="element-133" />
        </div>
      </motion.div>

      {/* Heading */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-center space-y-4" data-id="element-134">
        <h2 className="text-4xl md:text-5xl font-serif text-white" data-id="element-135">
          Why AI Alone Isn't Enough
        </h2>
        <p className="text-xl text-white/60" data-id="element-136">
          Generative AI solves creation. It does not solve execution.
        </p>
      </motion.div>

      {/* Cards */}
      <div className="flex-1 grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch mt-12 w-full max-w-5xl" data-id="element-137">
        {/* The Promise */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: stage >= 1 ? 1 : 0,
        y: stage >= 1 ? 0 : 20
      }} className="bg-gradient-to-r from-teal-400/10 to-purple-500/10 border border-teal-400/20 rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-138">
          <h3 className="text-2xl font-serif text-white mb-2" data-id="element-139">
            The Promise of AI
          </h3>
          <p className="text-white/70 leading-relaxed" data-id="element-140">
            AI dramatically reduces the cost of content creation, making it
            theoretically possible to support the long tail of legacy brands.
          </p>
        </motion.div>

        {/* The Reality */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: stage >= 2 ? 1 : 0,
        x: stage >= 2 ? 0 : 20
      }} className="bg-gradient-to-r from-teal-400/10 to-purple-500/10 border border-teal-400/20 rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-141">
          <h3 className="text-2xl font-serif text-white mb-2" data-id="element-142">The Reality</h3>
          <p className="text-white/70 leading-relaxed" data-id="element-143">
            What actually moves legacy revenue is strategy, compliance,
            distribution, and measurement working together as a system.
          </p>
        </motion.div>

        {/* Execution is the Bottleneck */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: stage >= 3 ? 1 : 0,
        y: stage >= 3 ? 0 : 20
      }} className="bg-gradient-to-r from-teal-400/10 to-purple-500/10 border border-teal-400/20 rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-144">
          <h3 className="text-2xl font-serif text-white mb-2" data-id="element-145">
            Closed Loop Marketing
          </h3>
          <p className="text-white/80 text-lg" data-id="element-146">
            To unlock legacy value, you need a technology that not only
            automates the campaign lifecycle, but turns every encounter into a
            lesson learned.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: stage >= 4 ? 1 : 0
      }} className="mt-12 flex justify-center" data-id="element-147">
          <Button onClick={onContinue} data-id="element-148">New Category</Button>
        </motion.div>
      </div>
    </div>;
}